import React, { useState, useEffect, useCallback, forwardRef, useImperativeHandle } from 'react';
import { Row, Col, Card, OverlayTrigger, Tooltip, Form } from 'react-bootstrap';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-datepicker/dist/react-datepicker.css';
import config from '../../config';




function PayScheduleFrequency({ caseId, onError = () => { } }) {
    const [schedules, setSchedules] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const options = [
        { value: 'weekly', label: 'Weekly' },
        { value: 'biweekly', label: 'Bi-Weekly' },
        { value: 'monthly', label: 'Monthly' },
        { value: 'semimonthly', label: 'Semi-Monthly' },
        { value: 'other', label: 'Other' }
    ];



    useEffect(() => {
        const fetchSchedules = async () => {
            setLoading(true); 

            try {
                const response = await axios.get(`${config.API_URL}/PayScheduleFrequencies/ByCaseId/${caseId}`);
                const fetchedSchedules = response.data || [];

                
                setSchedules(fetchedSchedules);

                
            } catch (error) {
                if (error.response?.status !== 404) {
                    setError('Error fetching case files.');
                }
                onError(error);
            } finally {
                setLoading(false);
            }
        };

        fetchSchedules();
    }, [caseId]); 



    return (
        <div className="table-responsive">
          <table className="styled-table table-hover mb-0">
            
                <thead>
                    <tr>
                        
                        <th><strong>Pay Schedule Frequency</strong></th>
                        <th><strong>First Paycheck Date in New Plan Year</strong></th>
                        </tr>
                        </thead>
                
            
            <tbody>
              {schedules.map((schedule, index) => {
                const scheduleOption = options?.find(option => option.value === schedule.scheduleFrequency);
                return (
                  <tr key={index}>
                    
                    {schedule.scheduleFrequency === 'other' ? (
                      <td>{schedule.otherScheduleFrequency || ''}</td>
                    ):(<td>{scheduleOption ? scheduleOption.label : ''}</td>)}
                    <td>{schedule.payDate || ''}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      );
      
};

export default PayScheduleFrequency;


